// @ts-strict-ignore
import type { MatchData, ResolutionPayload } from '../../types';
import { resolvableServices } from '../constants';

type ResolveByServiceProps = {
  selectedMatches: MatchData[];
  note: string;
  reason: string;
  isSuppressed: boolean;
  handleResolve: (ResolutionPayload) => void;
  setSubmitting: React.Dispatch<React.SetStateAction<boolean>>;
};

export const isResolvable = match => {
  if ({}.hasOwnProperty.call(match, 'is_resolvable')) {
    return match.is_resolvable;
  }
  return match.is_supported && resolvableServices[match.service];
};

export const resolveByService = async ({
  selectedMatches,
  note,
  reason,
  isSuppressed,
  handleResolve,
  setSubmitting,
}: ResolveByServiceProps) => {
  const resolutionsPerService = selectedMatches
    .filter(match => isResolvable(match))
    .reduce(
      (acc, match) => {
        if (!acc[match.service]) {
          const {
            service,
            vendor_search_identifier: vendorSearchIdentifier,
            vendor_alert_identifier: vendorAlertIdentifier,
            vendor_profile_identifier: vendorProfileIdentifier,
          } = match;

          acc[match.service] = {
            note,
            is_suppressed: isSuppressed,
            reason,
            service_name: service,
            vendor_entity_identifiers: [],
            vendor_search_identifier: vendorSearchIdentifier,
            vendor_alert_identifier: vendorAlertIdentifier,
            vendor_profile_identifier: vendorProfileIdentifier,
            match_types_by_vendor_entity_id: {},
            watchlist_hit_tokens: [],
          };
        }
        acc[match.service].vendor_entity_identifiers.push(match.vendor_entity_identifier);
        (acc[match.service].match_types_by_vendor_entity_id ??= {})[
          match.vendor_entity_identifier] = match.match_types
          .filter(({ label }) => !!label)
          .map(({ label }) => ({ label }));
        if (match.watchlist_hit_token) {
          acc[match.service].watchlist_hit_tokens.push(match.watchlist_hit_token);
        }
        return acc;
      },
      {} as { [key: string]: ResolutionPayload },
    );
  setSubmitting(true);
  Promise.all(
    Object.values(resolutionsPerService).map(resolution => handleResolve(resolution)),
  ).then(() => {
    setSubmitting(false);
  });
};
